import * as types from '../actiontypes';
import {GetAllScotsUrl, GetAllItsoApplicationsUrl, GetAllItProcessUrl, createApiAction} from '../apiUrls';

/**
 * Returns an action to be dispatched and treated by the api-middleware, ultimately making an API call through Axios.
 * Represents a request for all of the ITSO Applications in the specified Engagement.
 * @param {Number} engagementId The Engagement ID.
 * @returns {Object} An action object to be dispatched and treated by the api-middleware.
 */
export const getEngagementITSOApps = (engagementId) => {
	const url = GetAllItsoApplicationsUrl(engagementId);

	const action = createApiAction(types.GET_ALL_ITSOAPPLICATIONS, url, 'GET');
	action.resolve = true;
	return action;
};

/**
 * Returns an action to be dispatched and treated by the api-middleware, ultimately making an API call through Axios.
 * Represents a request for all of the IT Processes in the specified Engagement.
 * @param {Number} engagementId The Engagement ID.
 * @param {String} [expand] The entity to expand.
 * @returns {Object} An action object to be dispatched and treated by the api-middleware.
 */
export const getEngagementITProcesses = (engagementId, expand) => {
	let includeITRiskAndITControl;

	if (expand) {
		includeITRiskAndITControl = true;
	}

	const url = GetAllItProcessUrl(engagementId, {expand, includeITRiskAndITControl});

	const action = createApiAction(types.GET_ALL_ITPROCESSES, url, 'GET');
	action.resolve = true;
	return action;
};

/**
 * Returns an action to be dispatched and treated by the api-middleware, ultimately making an API call through Axios.
 * Represents a request for all of the Scots in the specified Engagement.
 * @param {Number} engagementId The Engagement ID.
 * @param expand
 * @param searchString
 * @param assertionId
 * @param accountId
 * @param validateTasksInCounter
 * @param includeAssertion
 */
export const getEngagementScots = (
	engagementId,
	expand,
	searchString,
	assertionId,
	accountId,
	validateTasksInCounter,
	includeAssertion
) => {
	let includeControl, includeWcgw;

	if (expand) {
		if (expand.toLowerCase().includes('controls')) {
			includeControl = true;
		}
		if (expand.toLowerCase().includes('wcgw.controls') || expand.toLowerCase().includes('wcgw')) {
			includeWcgw = true;
		}
	}

	const urlParams = {
		searchString,
		assertionId,
		accountId,
		validateTasksInCounter,
		includeControl,
		includeWcgw,
		includeROMM: true,
		includeAssertion: includeAssertion === undefined ? false : includeAssertion
	};

	const url = GetAllScotsUrl(engagementId, urlParams);

	const action = createApiAction(types.GET_All_SCOTS, url, 'GET');
	action.resolve = true;
	if (action.expand) {
		action.expand = expand;
	}
	return action;
};
